import { request } from '@/services/request';
import { AppList } from 'types/app-list';

/**
 * Fetches the list of applications available for a user.
 */
export const getApps = async (): Promise<AppList> => {
  try {
    const data = await request.get({ endpoint: 'apps' });
    const apps = data[0]?.apps || [];
    return apps;
  } catch (error) {
    console.error('Failed to fetch apps:', error);
    return [];
  }
};

/**
 * Fetches the details of a specific application.
 * @param appName - name of the application
 * @param queryParams - additional query parameters
 * @returns - details of the application like owner, sla, components etc.
 */
export const getAppsDetails = async (
  appName: string,
  queryParams: Record<string, any>
) => {
  try {
    const data = await request.get({
      endpoint: `apps/${appName}`,
      queryParams,
    });

    return data[0];
  } catch (error) {
    throw new Error(`Failed to fetch app details: ${error}`);
  }
};
